export default __webpack_public_path__ + "static/media/randomizer.8f3c7395.png";